import type { RemoteApplicationConfig, RouteRecord } from "@lst/ui-components-vue";

const routes: RouteRecord[] = [{
    path: "/utilities",
    component: () => import("./views/Utilities/Page.vue"),
    meta: {
        key: "utilities",
        title: "Utilities",
        showInSideNav: true,
    },
}];

export const config: RemoteApplicationConfig = { routes };
